export default "/build/images/pdf.png?3842b8c33140b91db92865d827163686";